import { Box, Typography } from '@mui/material'
import { propertyChipConfig, propertyChipConfigCompact } from './PropertyDefinitionChip.tsx'
import type { Theme } from '@mui/material/styles'

interface NewPropChipButtonProps {
  onClick: () => void
  color: string
  compact?: boolean
}

export function NewPropChipButton({ onClick, color, compact }: NewPropChipButtonProps) {
  const cfg = compact ? propertyChipConfigCompact : propertyChipConfig
  return (
    <>
      <Box
        sx={{
          border: `2px solid ${color}`,
          borderRadius: '6px',
          height: cfg.height,
          width: compact ? '130px' : '160px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          '&:hover': {
            '& .MuiTypography-root': {
              color: (theme: Theme) => theme.palette.secondary.main,
            },
            borderColor: (theme: Theme) => theme.palette.secondary.main,
          },
        }}
        onClick={onClick}
      >
        <Typography
          color={color}
          variant="body2"
          fontSize={cfg.fontSize}
          sx={{
            '&:hover': {
              borderColor: (theme: Theme) => theme.palette.secondary.main,
            },
          }}
        >
          + New Property
        </Typography>
      </Box>
    </>
  )
}
